import { useGlobalSearch } from "@/src/contexts/GlobalSearchContext"
import { useEffect } from "react"

const Page = () => {
  const { openSearch, closeSearch, lastVisitedUrl } = useGlobalSearch()

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data === "OPEN_MODAL") {
        openSearch()
      }

      if (event.data === "CLOSE_MODAL") {
        closeSearch()
      }
    }

    const handleKeyDown = (e: KeyboardEvent) => {
      window.parent.postMessage(
        {
          type: "IFRAME_KEYDOWN",
          key: e.key,
          metaKey: e.metaKey,
          ctrlKey: e.ctrlKey
        },
        "*"
      )
    }

    window.addEventListener("message", handleMessage)
    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("message", handleMessage)
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [openSearch, closeSearch])

  useEffect(() => {
    if (lastVisitedUrl) {
      window.parent.postMessage(
        { type: "ROUTE_CHANGE", url: lastVisitedUrl },
        "*"
      )
    }
  }, [lastVisitedUrl])

  return null
}

export default Page
